import { OrderItem, SequencingPrimer } from './order';
export class CancelOrderItemRequest{
    orderId: string;
    orderItemIds: string[];
    orderItems: Array<OrderItem>;
    sequencingPrimers: Array<SequencingPrimer>;
}